import { Injectable } from '@angular/core';
import { Purchaseorderdto } from '../model/purchageorderdto';

@Injectable({
  providedIn: 'root'
})
export class UIStateService {
  private state: UIState;

  constructor() { }
  setState(state: UIState) {
    this.state = state;
  }
  getState(): UIState {
    return this.state ? this.state : {search: "1", dateRange : "", username : "",intialPurchaseOrderListOne: []
  } /** default state*/;
  }

}
export interface UIState {
  search: string;
 
  dateRange : string;
  username : string;
  intialPurchaseOrderListOne: Purchaseorderdto[];
  
}
